import * as ko from 'knockout'
import '@classic/AppUtils/Framework/CustomBindings/StickyBinding'
import template from './info-toolbar-wrapper.tpl.html'
import { InfoToolbarViewModel, Params } from './InfoToolbarViewModel'

if (!ko.components.isRegistered('info-toolbar')) {
  ko.components.register('info-toolbar', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new InfoToolbarViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
